/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Tab } from '@mui/material';
import { CheckBoxComp, DatePickers, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { VacancyDTO, UserDTO, ValueListDTO, CompanyFilterDTO, UserFilterDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import { CompanyDTO } from '../../../shared/interfaces/corpSphere/CompanyDTO';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useTranslation } from 'react-i18next';

interface IAssessmentProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const Assessment: React.FC<IAssessmentProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [vacancyDTO, setVacancyDTO] = useState<VacancyDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [tabIndex, setTabIndex] = React.useState('1');

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setVacancyDTO({
            ...vacancyDTO,
        } as VacancyDTO);

        handleGetVacancyByIdAsync();
    }, [data, isOpenMaintenance]);

    const handleGetVacancyByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('talentsphere.vacancy', data.id, setLoading, setVacancyDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = vacancyDTO as VacancyDTO;

        if (vacancyDTO?.id === '' || vacancyDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('talentsphere.vacancy', dto, setVacancyDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('talentsphere.vacancy', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [vacancyDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: t('vacancy.dialogActions.save'), icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'cancel', text: t('vacancy.dialogActions.cancel'), icon: 'cancel_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabIndex(newValue);
    };

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={`${t('vacancy.assessment.dialogForm')} - ${vacancyDTO?.code}}`}
                icon='checked_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='hasBehavioralTest'
                                label={t('vacancy.assessment.behavioralTest')}
                                setValue={setVacancyDTO}
                                objDTO={vacancyDTO}
                                defaultChecked={vacancyDTO?.hasBehavioralTest ?? true}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='hasSituationalTest'
                                label={t('vacancy.assessment.situationalTest')}
                                setValue={setVacancyDTO}
                                objDTO={vacancyDTO}
                                defaultChecked={vacancyDTO?.hasSituationalTest}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='hasTechnicalTest'
                                label={t('vacancy.assessment.technicalTest')}
                                setValue={setVacancyDTO}
                                objDTO={vacancyDTO}
                                defaultChecked={vacancyDTO?.hasTechnicalTest}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <CheckBoxComp
                                id='hasPraticalTest'
                                label={t('vacancy.assessment.praticalTest')}
                                setValue={setVacancyDTO}
                                objDTO={vacancyDTO}
                                defaultChecked={vacancyDTO?.hasPraticalTest}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TabContext value={tabIndex} >
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label={t('vacancy.assessment.labApiTabsExemple')}>
                                        {vacancyDTO?.hasBehavioralTest ? (<Tab label={t('vacancy.assessment.behavioralTest')} value="1" />) : undefined}
                                        {vacancyDTO?.hasSituationalTest ? (<Tab label={t('vacancy.assessment.situationalTest')} value="2" />) : undefined}
                                        {vacancyDTO?.hasTechnicalTest ? (<Tab label={t('vacancy.assessment.technicalTest')} value="3" />) : undefined}
                                        {vacancyDTO?.hasPraticalTest ? (<Tab label={t('vacancy.assessment.praticalTest')} value="4" />): undefined}
                                    </TabList>
                                </Box>
                                <TabPanel value="1" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='behavioralTest'
                                                label={t('vacancy.assessment.behavioralTest')}
                                                value={vacancyDTO?.behavioralTest}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={18}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='situationalTest'
                                                label={t('vacancy.assessment.situationalTest')}
                                                value={vacancyDTO?.situationalTest}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={18}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="3" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='technicalTest'
                                                label={t('vacancy.assessment.technicalTest')}
                                                value={vacancyDTO?.technicalTest}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={18}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="4" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='praticalTest'
                                                label={t('vacancy.assessment.praticalTest')}
                                                value={vacancyDTO?.praticalTest}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={18}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};
